import { render } from "./06_AgreementPage.vue?vue&type=template&id=848e1c3e&scoped=true"
import script from "./06_AgreementPage.vue?vue&type=script&lang=js"
export * from "./06_AgreementPage.vue?vue&type=script&lang=js"

import "./06_AgreementPage.vue?vue&type=style&index=0&id=848e1c3e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-848e1c3e"]])

export default __exports__